/*
 *  Module for performing autoscroll of a div
 */

rs.module("common/auto-scroll",

	// dependencies
	[],

	function () {

		var _autoScroll = true;
		var _previousScrollY = 0;

		// Perform automatic scrolling of an element, except when the user scrolls themselves
		function autoscroll(element, contentChangeCallback) {

			// only keep the callback around if it's a function as desired 
			contentChangeCallback = (typeof contentChangeCallback === "function") ? contentChangeCallback : null;

			// get the element to be scrolled, unwrapping from jquery if needed
			var elementToScroll = element.jquery ? element.get(0) : element;

			// listen to scroll so we can tell if we should start or stop autoscrolling
			$(elementToScroll).on('scroll', function () {

				var currentScrollY = $(elementToScroll).scrollTop();

				// scrolling away from the bottom, disable autoscrolling
				if (_previousScrollY > currentScrollY) {
					_autoScroll = false;
				}

				// scrolled to the bottom, (re)enable autoscrolling
				if (elementToScroll.scrollHeight - currentScrollY <= Math.round($(elementToScroll).outerHeight())) {
					_autoScroll = true;
				}

				_previousScrollY = currentScrollY;
			});

			// setup an observer which updates scroll position when content is changed
			var contentObserver = new MutationObserver(function () {
				if (_autoScroll) {
					$(elementToScroll).scrollTop(elementToScroll.scrollHeight);
				}

				// notify listener that content changed
				if (contentChangeCallback) {
					contentChangeCallback();
				}
			});

			// begin listening for changes
			contentObserver.observe(elementToScroll, { childList: true, subtree: true });
		}

		var exports = {
			autoscroll: autoscroll
		};

		return exports;
	}
);